import React, { memo } from "react";

export type TooltipProps = {
  children: React.ReactNode;
  text: string;
  wrapperClass?: string;
};

const Tooltip: React.FC<TooltipProps> = memo((props) => {
  const wrapperClass = props.wrapperClass
    ? props.wrapperClass
    : "whitespace-nowrap -top-8 px-2 py-1";
  return (
    <span className="group cursor-pointer relative">
      <span
        className={
          "pointer-events-none absolute rounded shadow-lg bg-white opacity-0 transition before:absolute left-1/2 -translate-x-1/2 before:left-1/2 before:top-full before:-translate-x-1/2 before:border-4 before:border-transparent before:border-t-white before:content-[''] group-hover:opacity-100 " +
          wrapperClass
        }
      >
        {props.text}
      </span>

      {props.children}
    </span>
  );
});

Tooltip.displayName = "Tooltip";

export default Tooltip;
